export class TimeseriesController {
  constructor() {

  }
}




/** WEBPACK FOOTER **
 ** ./app/meteostation/timeseries/timeseries.controller.ts
 **/